import { values } from '../_helpers'

const _enum = {
  dry: 0,
  offDry: 1,
  mediumDry: 2,
  mediumSweet: 3,
  sweet: 4
}

const sweetness = { ..._enum, name: 'sweetness', values: values(_enum) }

export {
  sweetness
}
